export type PostServiceOrderActionForApproveClaimApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceOrderActionForApproveClaimApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
};
export type PostServiceOrderActionForRejectClaimApiResponse =
  /** status 204 Standard response */ undefined;
export type PostServiceOrderActionForRejectClaimApiArg = {
  /** UUID */
  serviceCaseId: string;
  /** UUID */
  serviceOrderId: string;
  body: {
    reason: string;
    isDuplicateToOrder: boolean;
    serviceOrderVariantId?: string;
  };
};
